export enum SocialsEnum {
  youtube = "https://www.youtube.com/channel/UCqN6lrKJtJ4WvkNto9C-FUw",
  facebook = "https://www.facebook.com/RIVVAL/",
  linkedin = "https://www.linkedin.com/company/rivval",
  twitter = "https://www.twitter.com/rivval_ltd",
}
